import { useState } from "react";
import { Box, CircularProgress, InputAdornment, Typography } from "@mui/material";
import { StyledIconButton } from "@hcl-commerce-store-sdk/react-component";
import { SvgLocalisation } from "../../../svg/localisation";

interface PincodeLocateProps {
  setZipCode: (pincode: string) => void;
}

export const PincodeLocater: React.FC<PincodeLocateProps> = ({ setZipCode }) => {
  const [loadingLocation, setLoadingLocation] = useState(false);
  const [postalCodeValue, setPostalCodeValue] = useState<string>("");

  const getPostalCodeFromLatLng = (lat: number, lng: number): Promise<string | null> => {
    return new Promise((resolve, reject) => {
      if (!window.google || !window.google.maps) {
        reject("Google Maps not loaded");
        return;
      }

      const geocoder = new window.google.maps.Geocoder();

      geocoder.geocode({ location: { lat, lng } }, (results, status) => {
        if (status !== "OK" || !results) {
          reject("Geocoder failed");
          return;
        }

        for (const result of results) {
          const postal = result.address_components.find((comp) => comp.types.includes("postal_code"));
          if (postal) {
            resolve(postal.long_name);
            return;
          }
        }

        resolve(null);
      });
    });
  };

  const handleGetPincode = () => {
    if (!navigator.geolocation) {
      console.error("Geolocation not supported");
      return;
    }

    setLoadingLocation(true);

    navigator.geolocation.getCurrentPosition(
      async (position) => {
        try {
          const lat = position.coords.latitude;
          const lng = position.coords.longitude;

          console.log("position", position);

          const pincode = await getPostalCodeFromLatLng(lat, lng);

          if (pincode) {
            setZipCode(pincode);
            console.log("Pincode:", pincode);
          } else {
            console.warn("Pincode not found");
          }
        } catch (err) {
          console.error("Failed to get pincode:", err);
        } finally {
          setLoadingLocation(false);
        }
      },
      (error) => {
        console.error("Location error:", error);
        setLoadingLocation(false);
      }
    );
  };

  return (
    <InputAdornment
      position="end"
      sx={{
        m: 0,
        p: 0,
        height: "100%",
        maxHeight: "100%",
      }}>
      <StyledIconButton
        className={loadingLocation ? "blink" : ""}
        onClick={handleGetPincode}
        sx={{
          m: 0,
          mb: {
            xs: 5,
            md: 0,
          },
          p: 0,
          minWidth: "unset",
          width: "auto",
          height: "100%",
          display: "flex",
          alignItems: "center",
          gap: "4px",
          "&:hover": {
            backgroundColor: "transparent",
          },
        }}>
        <SvgLocalisation />
        <Typography
          fontSize={13}
          fontWeight={400}
          color="#383838"
          sx={{
            lineHeight: "16px",
            textDecoration: "underline",
          }}>
          Me localiser
        </Typography>
        {loadingLocation && (
          <Box
            sx={{
              pl: 1,
              height: 4,
              display: "flex",
              alignItems: "center",
            }}>
            <CircularProgress size={12} sx={{ color: "#000000ff" }} />
          </Box>
        )}
      </StyledIconButton>
    </InputAdornment>
  );
};
